/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_Kb3Inputs */

const en_mk_cmp_linear_kb3 = /** @type {(inputs: Mk_Cmp_Linear_Kb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built-in agents per division, created and governed inside the product.`)
};

const id_mk_cmp_linear_kb3 = /** @type {(inputs: Mk_Cmp_Linear_Kb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen bawaan per divisi, dibuat dan diatur di dalam produk.`)
};

/**
* | output |
* | --- |
* | "Built-in agents per division, created and governed inside the product." |
*
* @param {Mk_Cmp_Linear_Kb3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_kb3 = /** @type {((inputs?: Mk_Cmp_Linear_Kb3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_Kb3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_kb3(inputs)
	return en_mk_cmp_linear_kb3(inputs)
});